module.exports = __webpack_public_path__ + "img/install-ketang.8d4ae1b3.jpg";